import fetch from "auth/FetchInterceptor";

const UploadFileService = {};

UploadFileService.upload = function (payload) {
  return fetch({
    url: "/upload-file",
    method: "post",
    headers: { "Content-Type": "multipart/form-data" },
    data: payload.formData
  });
};

UploadFileService.uploadProfilePicOrInsuranceIdServiceload = function (payload) {
  console.log("UploadFileService", payload)
  return fetch({
    url: "/upload/upload-profile-pic-insurance-id",
    method: "post",
    headers: { "Content-Type": "multipart/form-data" },
    data: payload.formData
  });
};

export default UploadFileService;